import MaterialTooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';

const Tooltip = ({ title, arrow, placement, classes, children, hidden }) => {
  if (!title || hidden) return children;

  return (
    <MaterialTooltip arrow={arrow} classes={classes} placement={placement} title={title}>
      <span id="tooltipAnchorForDisabledElements">{children}</span>
    </MaterialTooltip>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  arrow: PropTypes.bool,
  classes: PropTypes.shape(),
  hidden: PropTypes.bool,
  placement: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

Tooltip.defaultProps = {
  arrow: false,
  classes: undefined,
  hidden: false,
  placement: 'top',
  title: undefined,
};

export default React.memo(Tooltip);
